import React from 'react';
import Errors from 'pages/errors/page.jsx';
const ErrorFallback = () => {
  return <Errors firstPara="Uh oh.." btnText="Try again" naviUrl1="/" />;
};

export default ErrorFallback;
